import { ReleaseEnvironment } from "./release-environment";

export class EnvironmentListComparison {
  before: ReleaseEnvironment[];
  after: ReleaseEnvironment[];

  public constructor(before: ReleaseEnvironment[], after: ReleaseEnvironment[]) {
    this.before = before;
    this.after = after;
  }
}